document.addEventListener('DOMContentLoaded', function () {
    var stage = document.querySelector('[data-hero-stage]');

    if (!stage) {
        return;
    }

    var introLoader = stage.querySelector('[data-hero-loader]');
    var introLoaderCount = stage.querySelector('[data-hero-loader-count]');
    var headerLogoLink = stage.querySelector('[data-hero-logo-link]');
    var headerLogoTarget = stage.querySelector('[data-hero-logo-target]');
    var buttons = Array.prototype.slice.call(stage.querySelectorAll('[data-panel-target]'));
    var panels = Array.prototype.slice.call(stage.querySelectorAll('[data-panel]'));
    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var activePanelKey = '';
    var introStartRect = null;
    var introTargetRect = null;
    var lastTrigger = null;

    function isIntroLocked() {
        return stage.classList.contains('is-intro-active') || stage.classList.contains('is-intro-resolving');
    }

    function setIntroProgress(value) {
        if (introLoaderCount) {
            introLoaderCount.textContent = value + '%';
        }
    }

    function getPanel(key) {
        return panels.find(function (panel) {
            return panel.dataset.panel === key;
        });
    }

    function updatePanelBodyState(panel) {
        var body = panel.querySelector('[data-panel-body]');

        if (!body) {
            return;
        }

        var isScrollable = body.scrollHeight > body.clientHeight + 6;
        var isAtEnd = body.scrollTop + body.clientHeight >= body.scrollHeight - 6;

        body.dataset.scrollable = isScrollable ? 'true' : 'false';
        body.dataset.scrollEnd = isAtEnd ? 'true' : 'false';
    }

    function setButtonState(activeKey) {
        buttons.forEach(function (button) {
            var isActive = button.dataset.panelTarget === activeKey;
            button.classList.toggle('is-active', isActive);
            button.setAttribute('aria-expanded', isActive ? 'true' : 'false');
        });
    }

    function revealPanel(panel) {
        if (!panel) {
            return;
        }

        var card = panel.querySelector('.bubble-panel__card');

        panel.offsetHeight;
        panel.classList.add('is-visible');
        updatePanelBodyState(panel);

        if (card) {
            card.focus({ preventScroll: true });
        }
    }

    function closePanel(focusTarget) {
        if (!activePanelKey) {
            return;
        }

        var currentPanel = getPanel(activePanelKey);

        if (!focusTarget) {
            focusTarget = lastTrigger;
        }

        if (currentPanel) {
            if (focusTarget && document.activeElement && currentPanel.contains(document.activeElement) && typeof focusTarget.focus === 'function') {
                focusTarget.focus({ preventScroll: true });
            } else if (document.activeElement && currentPanel.contains(document.activeElement) && typeof document.activeElement.blur === 'function') {
                document.activeElement.blur();
            }

            currentPanel.classList.remove('is-open', 'is-visible');
            currentPanel.setAttribute('aria-hidden', 'true');
        }

        activePanelKey = '';
        lastTrigger = null;
        stage.removeAttribute('data-active-panel');
        document.body.classList.remove('has-open-panel');
        setButtonState('');
    }

    function openPanel(panelKey, button) {
        var panel = getPanel(panelKey);

        if (!panel || !button) {
            return;
        }

        if (activePanelKey && activePanelKey !== panelKey) {
            closePanel(button);
        }

        activePanelKey = panelKey;
        lastTrigger = button;
        stage.dataset.activePanel = panelKey;
        document.body.classList.add('has-open-panel');
        setButtonState(panelKey);

        var body = panel.querySelector('[data-panel-body]');

        if (body) {
            body.scrollTop = 0;
        }

        panels.forEach(function (item) {
            var isCurrent = item.dataset.panel === panelKey;
            item.classList.toggle('is-open', isCurrent);
            item.classList.remove('is-visible');
            item.setAttribute('aria-hidden', isCurrent ? 'false' : 'true');
        });

        revealPanel(panel);
    }

    function finishIntro() {
        stage.classList.remove('is-intro-active', 'is-intro-resolving');
        stage.classList.add('is-intro-complete');
        document.body.classList.remove('has-intro-loader');
        stage.style.removeProperty('--intro-shift-x');
        stage.style.removeProperty('--intro-shift-y');
        stage.style.removeProperty('--intro-scale');

        if (introLoader) {
            introLoader.hidden = true;
        }
    }

    function resolveIntro() {
        if (!introLoader) {
            finishIntro();
            return;
        }

        stage.classList.remove('is-intro-active');
        stage.classList.add('is-intro-resolving');
        introLoader.classList.add('is-resolving');

        if (introStartRect && introTargetRect && introStartRect.width && introTargetRect.width) {
            var introCenterX = introStartRect.left + introStartRect.width / 2;
            var introCenterY = introStartRect.top + introStartRect.height / 2;
            var targetCenterX = introTargetRect.left + introTargetRect.width / 2;
            var targetCenterY = introTargetRect.top + introTargetRect.height / 2;
            var scale = introTargetRect.width / introStartRect.width;

            stage.style.setProperty('--intro-shift-x', targetCenterX - introCenterX + 'px');
            stage.style.setProperty('--intro-shift-y', targetCenterY - introCenterY + 'px');
            stage.style.setProperty('--intro-scale', scale);
        }

        window.setTimeout(function () {
            introLoader.classList.add('is-complete');
        }, prefersReducedMotion ? 20 : 720);

        window.setTimeout(function () {
            finishIntro();
        }, prefersReducedMotion ? 80 : 1020);
    }

    function captureIntroRects() {
        if (!headerLogoLink) {
            return;
        }

        stage.classList.remove('is-intro-active', 'is-intro-resolving', 'is-intro-complete');
        introTargetRect = headerLogoLink.getBoundingClientRect();

        stage.classList.add('is-intro-active');
        headerLogoLink.offsetHeight;
        introStartRect = headerLogoLink.getBoundingClientRect();
    }

    function runIntro() {
        if (!introLoader || !introLoaderCount || !headerLogoLink || !headerLogoTarget) {
            finishIntro();
            return;
        }

        introLoader.hidden = false;
        introLoader.classList.remove('is-resolving', 'is-complete');
        stage.classList.remove('is-intro-resolving', 'is-intro-complete');
        stage.classList.add('is-intro-active');
        document.body.classList.add('has-intro-loader');
        captureIntroRects();
        setIntroProgress(0);

        var duration = prefersReducedMotion ? 180 : 1900;
        var startTime = 0;
        var lastValue = -1;

        function step(timestamp) {
            if (!startTime) {
                startTime = timestamp;
            }

            var progress = Math.min((timestamp - startTime) / duration, 1);
            var eased = 1 - Math.pow(1 - progress, 3);
            var value = Math.min(100, Math.round(eased * 100));

            if (value !== lastValue) {
                setIntroProgress(value);
                lastValue = value;
            }

            if (progress < 1) {
                window.requestAnimationFrame(step);
                return;
            }

            window.setTimeout(resolveIntro, prefersReducedMotion ? 20 : 160);
        }

        window.requestAnimationFrame(step);
    }

    buttons.forEach(function (button) {
        button.addEventListener('click', function () {
            if (isIntroLocked()) {
                return;
            }

            var panelKey = button.dataset.panelTarget;

            if (panelKey === activePanelKey) {
                closePanel(button);
                return;
            }

            openPanel(panelKey, button);
        });
    });

    panels.forEach(function (panel) {
        var closeButton = panel.querySelector('[data-panel-close]');
        var body = panel.querySelector('[data-panel-body]');

        if (closeButton) {
            closeButton.addEventListener('click', function () {
                closePanel();
            });
        }

        if (body) {
            body.addEventListener('scroll', function () {
                updatePanelBodyState(panel);
            });
        }

        panel.addEventListener('click', function (event) {
            if (event.target === panel) {
                closePanel();
            }
        });
    });

    document.addEventListener('click', function (event) {
        if (!activePanelKey || isIntroLocked() || !(event.target instanceof Element)) {
            return;
        }

        if (event.target.closest('.bubble-panel__card') || event.target.closest('[data-panel-target]')) {
            return;
        }

        closePanel();
    });

    document.addEventListener('keydown', function (event) {
        if (isIntroLocked()) {
            return;
        }

        if (event.key === 'Escape') {
            closePanel();
        }
    });

    window.addEventListener('resize', function () {
        if (!activePanelKey) {
            return;
        }

        var activePanel = getPanel(activePanelKey);

        if (activePanel) {
            updatePanelBodyState(activePanel);
        }
    });

    runIntro();
});